import { createSelector } from 'reselect';

export const getInteractions = createSelector(
  state => state.tagging.interactions,
  interactions => interactions
);
